import { UserSettings } from '@griply/types';

export type UserTimeZoneUpdate = {
  timezone: string;
};

export const getUserTimeZoneUpdate = (
  settings: UserSettings | undefined,
  deviceTimeZone: string | undefined,
): UserTimeZoneUpdate | null => {
  if (!deviceTimeZone) {
    return null;
  }
  if (settings?.manualTimezone) {
    return null;
  }
  if (settings?.timezone === deviceTimeZone) {
    return null;
  }
  return { timezone: deviceTimeZone };
};

export type AutomaticTimeZoneUpdate = {
  manualTimezone: boolean;
  timezone?: string;
};

// ON snapshots the device zone immediately so the backend resync fires on the toggle, not the next focus.
export const getAutomaticTimeZoneUpdate = (
  automatic: boolean,
  deviceTimeZone: string | undefined,
): AutomaticTimeZoneUpdate => {
  if (!automatic) {
    return { manualTimezone: true };
  }
  return { manualTimezone: false, timezone: deviceTimeZone };
};
